(function(viewModel) {
    var _permissionData = ko.observableArray([]);
    var _packagesData = ko.observableArray([]);
    viewModel.permission = {
        init: function(data, packages) { // this function call from extend-moveinUi-viewModel.js line 201 to assign user rights
        	if (typeof data == 'undefined') {
        		data = [];
        	}
            if (typeof packages == 'undefined') {
                packages = [];
            }
            _packagesData(packages);
            _permissionData(data);
            viewModel.permission.permissionDataPromise.resolve();
        },
        userRightsLoaded: $.Deferred(),
        packagesData: _packagesData,
        permissionData: _permissionData,
        permissionDataPromise: viewModel.getPromise(),
        checkRights: function(id, right) {
        	//return true;
        	
        	if (moveInViewModel.multiProgram && moveInViewModel.multiProgram() === 0 && id == '10019') {
        		return false;	
        	}
        	
        	if ( pager.page.route[0] == 'label_administration_view') {
        		return true;
        	}
            var returnValue = false;
            if(_permissionData() instanceof Array) { //if multiple role is adde with user
                //if a role have id false and other role have id true then return true.
                for(var index in _permissionData()) {
                    for(var rightIndex in _permissionData()[index].rights) {
                        if(_permissionData()[index].rights[rightIndex].entity == id) {
                            returnValue = _permissionData()[index].rights[rightIndex][right] == 1 ? true : false;
                            if(returnValue == true) { // of one role have false value and other role have true value then it must return true
                                return returnValue;
                            }
                        }
                    }
                }
            } else { //if single role is added with user
                for(var index in _permissionData().rights) {
                    if(_permissionData().rights[index].entity == id) {
                        returnValue = _permissionData().rights[index][right] == 1 ? true : false;
                    }
                }
            }
            return returnValue;
        },
        checkMultiRights: function(ids, right, condition) {
            ids = (typeof ids == 'number' || typeof ids == 'string') ? [ids]: ids;
            var check = false;
            for (var i in ids) {
                var check = moveInViewModel.permission.checkRights(ids[i], right);

                if (condition === '||' && check === true) {
                    break;
                }

                if (condition === '&&' && check === false) {
                    break;
                }
            }

            return check;
        },
        
        checkMultipleIdRights: function(ids, right) { 
        	// ids may have single or multiple values in array. if one of id have true rights then it will return true.
        	//else it will return false if all have no rights.
            var returnValue = false;
            var multipleRightsCheck = false;
        	if (ids instanceof Array) {
            	ids.forEach(function(id) {
            		if (multipleRightsCheck === false) {
            			multipleRightsCheck = moveInViewModel.permission.checkRights(id, right);
            		}
            	});
            	returnValue = multipleRightsCheck;
            } else {
            	returnValue = moveInViewModel.permission.checkRights(ids, right);
            }
            return returnValue;
        },

        checkScoringSheetMenuRight: function(id, right) {
        	return true;
            var permissionData = _permissionData();
            permissionData = moveInViewModel.toArray(permissionData);

            var returnValue = false;
            //if a role have id false and other role have id true then return true.
            for(var index in permissionData) {
                for(var rightIndex in permissionData[index].rights) {
                    if(permissionData[index].rights[rightIndex].entity == id) {
                        returnValue = permissionData[index].rights[rightIndex][right] == 1 ? true : false;
                        if(returnValue == true) { // of one role have false value and other role have true value then it must return true
                            return returnValue;
                        }
                    }
                }
                //check to show the scoring sheet in the menu if the user is not a scoring admin and has at least one scoring type ticked
                for(var rightIndex in permissionData[index].scorerRights) {
                    if(permissionData[index].scorerRights[rightIndex][right] == 1) {
                        return true;
                    }
                }
            }

            return returnValue;
        },

        checkScorerRights: function(id, right) {
            if ( pager.page.route[0] == 'label_administration_view') {
                return true;
            }
            var returnValue = false;
            if(_permissionData() instanceof Array) { //if multiple role is adde with user
                //if a role have id false and other role have id true then return true.
                for(var index in _permissionData()) {
                    if (typeof _permissionData()[index].scorerRights !== 'undefined') {
                        for(var rightIndex in _permissionData()[index].scorerRights) {
                            if(_permissionData()[index].scorerRights[rightIndex].entity == id) {
                                returnValue = _permissionData()[index].scorerRights[rightIndex][right] == 1 ? true : false;
                                if(returnValue == true) { // of one role have false value and other role have true value then it must return true
                                    return returnValue;
                                }
                            }
                        }
                    }
                }
            } else { //if single role is added with user
                if (typeof _permissionData().scorerRights !== 'undefined') {
                    for(var index in _permissionData().scorerRights) {
                        if(_permissionData().scorerRights[index].entity == id) {
                            returnValue = _permissionData().scorerRights[index][right] == 1 ? true : false;
                        }
                    }
                }
            }
            return returnValue;
        },
        checkMultipleRights: function(id, right) {
            var returnValue = false;
            var rightsArr = right.split(', ');
            for(var splitIndex in rightsArr) {
                returnValue = moveInViewModel.permission.checkRights(id, rightsArr[splitIndex]);
                if(returnValue == false) { return returnValue };
            }
            return returnValue;
        },
        goTo: function(rightsId, right, href) { // go to href on click bind function , this function is not use right now. may be use in future. its for click binding.
            if(moveInViewModel.permission.checkRights(rightsId, right)) {
                window.location.href = '#'+href();
            }
        },
        checkRightsContactGridGuard: function(page, route, callback) {
            route = pager.page.route;
            $.when(moveInViewModel.permission.userRightsLoaded).then(function() {
                switch (route[0]) {
                    case 'contacts':
                        if (moveInViewModel.permission.checkRights(9089, 'rightView')) {
                            callback();
                        } else if (moveInViewModel.permission.checkRights(7846, 'rightView')) {
                            pager.navigate("#leads");
                        } else if (moveInViewModel.permission.checkRights(9088, 'rightView')) {
                            pager.navigate("#portalaccounts");
                        } else {
                            pager.navigate("#");
                        }
                        break;
                    case 'leads':
                        if (moveInViewModel.permission.checkRights(7846, 'rightView')) {
                            callback();
                        } else if (moveInViewModel.permission.checkRights(9089, 'rightView')) {
                            pager.navigate("#contacts");
                        } else if (moveInViewModel.permission.checkRights(9088, 'rightView')) {
                            pager.navigate("#portalaccounts");
                        } else {
                            pager.navigate("#");
                        }
                        break;
                    case 'portalaccounts':
                        if (moveInViewModel.permission.checkRights(9088, 'rightView')) {
                            callback();
                        } else if (moveInViewModel.permission.checkRights(9089, 'rightView')) {
                            pager.navigate("#contacts");
                        } else if (moveInViewModel.permission.checkRights(7846, 'rightView')) {
                            pager.navigate("#leads");
                        } else {
                            pager.navigate("#");
                        }
                        break;
                    case 'contacts-form':
                        if (moveInViewModel.permission.checkRights(9089, 'rightNew')) {
                            callback();
                        } else {
                            pager.navigate("#");
                        }
                        break;
                    case 'leads-form':
                        if (moveInViewModel.permission.checkRights(7846, 'rightNew')) {
                            callback();
                        } else {
                            pager.navigate("#");
                        }
                        break;
                }
            });
        },
        checkRightsFormGridGuard: function(page, route, callback) {
        	route = pager.page.route;
            $.when(moveInViewModel.permission.userRightsLoaded).then(function() {
            	switch (route[0]) {
            		case 'forms':
	            		if (moveInViewModel.permission.checkRights(9812, 'rightView')) {
	                		callback();
	                	} else if (moveInViewModel.permission.checkRights(9813, 'rightView')) {
	                		pager.navigate("#applications");
	                	} else if (moveInViewModel.permission.checkRights(9815, 'rightView')) {
	                		pager.navigate("#interviews");
	                	} else if (moveInViewModel.permission.checkRights(9894, 'rightView')) {
                            pager.navigate("#deposits");
                        } else if (moveInViewModel.permission.checkRights(9814, 'rightView')) {
	                		pager.navigate("#inquiries");
	                	} else if (moveInViewModel.permission.checkRights(10164, 'rightView')) {
                            pager.navigate("#events");
                        } else if (moveInViewModel.permission.checkRights(10164, 'rightView')) {
                            pager.navigate("#event-registration");
                        } else {
	                		pager.navigate("#");
	                	}
	            	break;
            		case 'applications':
                		if (moveInViewModel.permission.checkRights(9813, 'rightView')) {
                    		callback();
                    	} else if (moveInViewModel.permission.checkRights(9812, 'rightView')) {
                    		pager.navigate("#forms");
                    	} else if (moveInViewModel.permission.checkRights(9815, 'rightView')) {
                    		pager.navigate("#interviews");
                    	} else if (moveInViewModel.permission.checkRights(9894, 'rightView')) {
                            pager.navigate("#deposits");
                        } else if (moveInViewModel.permission.checkRights(9814, 'rightView')) {
                    		pager.navigate("#inquiries");
                    	} else if (moveInViewModel.permission.checkRights(10164, 'rightView')) {
                            pager.navigate("#events");
                        } else if (moveInViewModel.permission.checkRights(10164, 'rightView')) {
                            pager.navigate("#event-registration");
                        } else {
                    		pager.navigate("#");
                    	}
                	break;
            		case 'interviews':
                		if (moveInViewModel.permission.checkRights(9815, 'rightView')) {
                    		callback();
                    	} else if (moveInViewModel.permission.checkRights(9812, 'rightView')) {
                    		pager.navigate("#forms");
                    	} else if (moveInViewModel.permission.checkRights(9813, 'rightView')) {
                    		pager.navigate("#applications");
                    	} else if (moveInViewModel.permission.checkRights(9894, 'rightView')) {
                            pager.navigate("#deposits");
                        } else if (moveInViewModel.permission.checkRights(9814, 'rightView')) {
                    		pager.navigate("#inquiries");
                    	} else if (moveInViewModel.permission.checkRights(10164, 'rightView')) {
                            pager.navigate("#events");
                        } else if (moveInViewModel.permission.checkRights(10164, 'rightView')) {
                            pager.navigate("#event-registration");
                        } else {
                    		pager.navigate("#");
                    	}
                	break;
            		case 'deposits':
                        if (moveInViewModel.permission.checkRights(9894, 'rightView')) {
                            callback();
                        } else if (moveInViewModel.permission.checkRights(9812, 'rightView')) {
                            pager.navigate("#forms");
                        } else if (moveInViewModel.permission.checkRights(9813, 'rightView')) {
                            pager.navigate("#applications");
                        } else if (moveInViewModel.permission.checkRights(9815, 'rightView')) {
                            pager.navigate("#interviews");
                        } else if (moveInViewModel.permission.checkRights(9814, 'rightView')) {
                            pager.navigate("#inquiries");
                        } else if (moveInViewModel.permission.checkRights(10164, 'rightView')) {
                            pager.navigate("#events");
                        } else if (moveInViewModel.permission.checkRights(10164, 'rightView')) {
                            pager.navigate("#event-registration");
                        } else {
                            pager.navigate("#");
                        }
                    break;
            		case 'inquiries':
                		if (moveInViewModel.permission.checkRights(9814, 'rightView')) {
                    		callback();
                    	} else if (moveInViewModel.permission.checkRights(9812, 'rightView')) {
                    		pager.navigate("#forms");
                    	} else if (moveInViewModel.permission.checkRights(9813, 'rightView')) {
                    		pager.navigate("#applications");
                    	} else if (moveInViewModel.permission.checkRights(9815, 'rightView')) {
                    		pager.navigate("#interviews");
                    	} else if (moveInViewModel.permission.checkRights(9894, 'rightView')) {
                            pager.navigate("#deposits");
                        } else if (moveInViewModel.permission.checkRights(10164, 'rightView')) {
                            pager.navigate("#events");
                        } else if (moveInViewModel.permission.checkRights(10164, 'rightView')) {
                            pager.navigate("#event-registration");
                        } else {
                    		pager.navigate("#");
                    	}
                	break;
                    case 'events':
                        if (moveInViewModel.permission.checkRights(10164, 'rightView')) {
                            callback();
                        } else if (moveInViewModel.permission.checkRights(9812, 'rightView')) {
                            pager.navigate("#forms");
                        } else if (moveInViewModel.permission.checkRights(9813, 'rightView')) {
                            pager.navigate("#applications");
                        } else if (moveInViewModel.permission.checkRights(9815, 'rightView')) {
                            pager.navigate("#interviews");
                        } else if (moveInViewModel.permission.checkRights(9894, 'rightView')) {
                            pager.navigate("#deposits");
                        } else if (moveInViewModel.permission.checkRights(9814, 'rightView')) {
                            pager.navigate("#inquiries");
                        } else if (moveInViewModel.permission.checkRights(10164, 'rightView')) {
                            pager.navigate("#event-registration");
                        }  else {
                            pager.navigate("#");
                        }
                    break;
                    case 'event-registration':
                        if (moveInViewModel.permission.checkRights(10164, 'rightView')) {
                            callback();
                        } else if (moveInViewModel.permission.checkRights(9812, 'rightView')) {
                            pager.navigate("#forms");
                        } else if (moveInViewModel.permission.checkRights(9813, 'rightView')) {
                            pager.navigate("#applications");
                        } else if (moveInViewModel.permission.checkRights(9815, 'rightView')) {
                            pager.navigate("#interviews");
                        } else if (moveInViewModel.permission.checkRights(9894, 'rightView')) {
                            pager.navigate("#deposits");
                        } else if (moveInViewModel.permission.checkRights(9814, 'rightView')) {
                            pager.navigate("#inquiries");
                        } else if (moveInViewModel.permission.checkRights(10164, 'rightView')) {
                            pager.navigate("#events");
                        }  else {
                            pager.navigate("#");
                        }
                    break;
            	}
            });
        },
        
        checkRightsAutomatedExportGridGuard: function(page, route, callback) {
        	route = pager.page.route;
            $.when(moveInViewModel.permission.userRightsLoaded).then(function() {
            	switch (route[1]) {
            		case 'automated-export':
	            		if (moveInViewModel.permission.checkRights(9919, 'rightView')) {
	                		callback();
	                	} else if (moveInViewModel.permission.checkRights(9937, 'rightView')) {
	                		pager.navigate("#system-admin/automated-export-files");
	                	} else {
	                		pager.navigate("#");
	                	}
	            	break;
            		case 'automated-export-files':
                		if (moveInViewModel.permission.checkRights(9937, 'rightView')) {
                    		callback();
                    	} else if (moveInViewModel.permission.checkRights(9919, 'rightView')) {
                    		pager.navigate("#system-admin/automated-export");
                    	} else {
                    		pager.navigate("#");
                    	}
                	break;
            	}
            });
        },
        
        checkRightsStatusGuard: function(page, route, callback) {
            route = pager.page.route;
            $.when(moveInViewModel.permission.userRightsLoaded).then(function() {
                switch (route[1]) {
                    case 'lead-source-status':
                        if (moveInViewModel.permission.checkRights(9082, 'rightView')) {
                            callback();
                        } else if (moveInViewModel.permission.checkRights(7861, 'rightView')) {
                            pager.navigate("#system-admin/admission-status");
                        } else if (moveInViewModel.permission.checkRights(9727, 'rightView')) {
                            pager.navigate("#system-admin/interview-status");
                        } else if (moveInViewModel.permission.checkRights(9887, 'rightView')) {
                            pager.navigate("#system-admin/deposit-status");
                        } else {
                            pager.navigate("#");
                        }
                    break;
                    case 'admission-status':
                        if (moveInViewModel.permission.checkRights(7861, 'rightView')) {
                            callback();
                        } else if (moveInViewModel.permission.checkRights(9082, 'rightView')) {
                            pager.navigate("#system-admin/lead-source-status");
                        } else if (moveInViewModel.permission.checkRights(9727, 'rightView')) {
                            pager.navigate("#system-admin/interview-status");
                        } else if (moveInViewModel.permission.checkRights(9887, 'rightView')) {
                            pager.navigate("#system-admin/deposit-status");
                        } else {
                            pager.navigate("#");
                        }
                    break;
                    case 'interview-status':
                        if (moveInViewModel.permission.checkRights(9727, 'rightView')) {
                            callback();
                        } else if (moveInViewModel.permission.checkRights(9082, 'rightView')) {
                            pager.navigate("#system-admin/lead-source-status");
                        } else if (moveInViewModel.permission.checkRights(7861, 'rightView')) {
                            pager.navigate("#system-admin/admission-status");
                        } else if (moveInViewModel.permission.checkRights(9887, 'rightView')) {
                            pager.navigate("#system-admin/deposit-status");
                        } else {
                            pager.navigate("#");
                        }
                    break;
                    case 'deposit-status':
                        if (moveInViewModel.permission.checkRights(9887, 'rightView')) {
                            callback();
                        } else if (moveInViewModel.permission.checkRights(9082, 'rightView')) {
                            pager.navigate("#system-admin/lead-source-status");
                        } else if (moveInViewModel.permission.checkRights(7861, 'rightView')) {
                            pager.navigate("#system-admin/admission-status");
                        } else if (moveInViewModel.permission.checkRights(9727, 'rightView')) {
                            pager.navigate("#system-admin/interview-status");
                        } else {
                            pager.navigate("#");
                        }
                    break;
                }
            });
        },

        programAdminRightsGuard: function(page, route, callback) {
            route = pager.page.route;
            $.when(moveInViewModel.permission.userRightsLoaded).then(function() {
                switch (route[1]) {
                    case 'institution':
                        if (moveInViewModel.permission.checkRights(10089, 'rightView')) {
                            callback();
                        } else if (moveInViewModel.permission.checkRights(7850, 'rightView')) {
                            pager.navigate("#programme-admin/programme-type");
                        } else if (moveInViewModel.permission.checkRights(7850, 'rightView')) {
                            pager.navigate("#programme-admin/program");
                        } else if (moveInViewModel.permission.checkRights(7850, 'rightView')) {
                            pager.navigate("#programme-admin/intake");
                        } else if (moveInViewModel.permission.checkRights(20274, 'rightView')) {
                            pager.navigate("#programme-admin/rule");
                        } else {
                            pager.navigate("#");
                        }
                        break;
                    default:
                        if (moveInViewModel.permission.checkRights(7850, 'rightView')) {
                            callback();
                        } else if (moveInViewModel.permission.checkRights(10089, 'rightView')) {
                            pager.navigate("#programme-admin/institution");
                        } else {
                            pager.navigate("#");
                        }
                        break;
                }
            });
        },
        
        checkRightsGuard: function(page, route, callback, noCallback) {
            noCallback = isBlank(noCallback) ? true : noCallback;
            route = pager.page.route;
            var checkRights = true;
            var rightsId = '';
            var routeNames = [
                'leads',
                'opportunity',
                'message-center',
                'import-csv',
                'custom-area',
                'custom-attributes',
                'visibility-criteria',
                'modification-history-contact',
                'generated-pdf',
                'generated-csv-excel-files',
                'process-automation',
                'group-automation'
            ];
            if(route.length == 1 || routeNames.indexOf(route[0]) > -1) { // get rigths id from main menu
                for(var entity in moveInViewModel.menuConfig) {
                    for(var routeIndex in route) {
                        if(entity == route[routeIndex]) {
                            rightsId = moveInViewModel.menuConfig[entity].rightsId;
                        }
                    }
                }
            } else if (route[0] == 'system-admin') {
                var systemAdminKey = "system_admin";
                if(moveInViewModel.menuConfig[systemAdminKey]) {
                    var routePageName = route[1];
                    if (route[1] === "scoring-admin") {
                        routePageName = route[2];
                    }
                    if (route[1] === "application-admin") {
                        routePageName = route[2];
                    }
                    for (var subIndex in moveInViewModel.menuConfig[systemAdminKey].submenuItems) {
                        if (moveInViewModel.menuConfig[systemAdminKey].submenuItems[subIndex].alias == routePageName) {
                            rightsId = moveInViewModel.menuConfig[systemAdminKey].submenuItems[subIndex].rightsId;
                        }
                    }
                }
            }else if(route.length > 1 && route[0] != route[1]) { // get rights id from submenu
                if(moveInViewModel.menuConfig[route[0]]) {
                    for(var subIndex in moveInViewModel.menuConfig[route[0]].submenuItems) {
                        if(moveInViewModel.menuConfig[route[0]].submenuItems[subIndex].name == route[1]) {
                            rightsId = moveInViewModel.menuConfig[route[0]].submenuItems[subIndex].rightsId;
                            if(route.length == 3) { // check for menu sub menu.
                                for(var subIndex2 in moveInViewModel.menuConfig[route[0]].submenuItems[subIndex].submenuItems) {
                                    if(moveInViewModel.menuConfig[route[0]].submenuItems[subIndex].submenuItems[subIndex2].name == route[2]) {
                                        rightsId = moveInViewModel.menuConfig[route[0]].submenuItems[subIndex].submenuItems[subIndex2].rightsId;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            $.when(moveInViewModel.permission.userRightsLoaded).then(function() {
                if (!isBlank(rightsId)){ // if there is rights id then check rights against that rights id other wise it will be true.
                    checkRights = moveInViewModel.permission.checkRights(rightsId, 'rightView');
                }
                if (checkRights) {
                    if (noCallback != false) { callback(); }
                } else {
                    if (route[1] == 'entity_program_type' || route[1] == 'entity_program' || route[1] == 'entity_intake') {
                        if (route[1] == 'entity_program_type' &&  moveInViewModel.permission.checkRights('7850', 'rightView') == true) {
                            window.location.href = "#programme_admin/entity_program";
                        } else if (route[1] == 'entity_program_type' &&  moveInViewModel.permission.checkRights('7850', 'rightView') == true) {
                            window.location.href = "#programme_admin/entity_intake";
                        } else {
                            window.location.href = "#programme_admin";
                        }
                    } else if (route[1] === 'label_portal' || route[1] === 'entity_forms' || route[1] === 'entity_form_answers') {
                        if (route[1] == 'label_portal' &&  moveInViewModel.permission.checkRights('7854', 'rightView') == true) {
                            window.location.href = "#form_admin/entity_forms";
                        } else if (route[1] === 'label_portal' &&  moveInViewModel.permission.checkRights('7857', 'rightView') == true) {
                            window.location.href = "#form_admin/entity_form_answers";
                        } else {
                            window.location.href = "#form_admin";
                        }
                    } else {
                        window.location.href = "#";
                    }
                }
            });
        },
        checkRightGuardNew: function(page, route, callback, noCallback) { // check url for new
            noCallback = isBlank(noCallback) ? true : noCallback;
            var rightsId = '';
            var checkRights = true;
            if(route[0] == 'leads_view'){
                for(var entity in moveInViewModel.menuConfig) {
                    if(entity == 'leads') {
                        rightsId = moveInViewModel.menuConfig[entity].rightsId;
                    }
                }
            } else if(route[0] == 'opportunity_view') {
                for(var entity in moveInViewModel.menuConfig) {
                    if(entity == 'opportunity') {
                        rightsId = moveInViewModel.menuConfig[entity].rightsId;
                    }
                }
            }
            //this check is apply to resolved issue of new page or reload page. this will wiat for rights loaded for current user after that it will check.
            $.when(moveInViewModel.permission.userRightsLoaded).then(function() {
                if(!isBlank(rightsId)){ // if there is rights id then check rights against that rights id other wise it will be true.
                    checkRights = moveInViewModel.permission.checkRights(rightsId, 'rightNew');
                }

                if(checkRights) {
                    if(noCallback != false) { callback(); }
                } else {
                    window.location.href = "#";
                }
            });
        },
        getRightsIdByEntityName: function(entityName) { // this function is changed latr. to use pager route. we have issue with entity name thats why.
            var rightsId = '';
            for(var entity in moveInViewModel.menuConfig) {
                if(entity == entityName) {
                    return moveInViewModel.menuConfig[entity].rightsId;
                }
                for(var subIndex in moveInViewModel.menuConfig[entity].submenuItems) {
                    if(moveInViewModel.menuConfig[entity].submenuItems[subIndex].name == entityName) {
                        return moveInViewModel.menuConfig[entity].submenuItems[subIndex].rightsId;
                    }
                    for(var subIndex2 in moveInViewModel.menuConfig[entity].submenuItems[subIndex].submenuItems) {
                        if(moveInViewModel.menuConfig[entity].submenuItems[subIndex].submenuItems[subIndex2].name == entityName) {
                            return moveInViewModel.menuConfig[entity].submenuItems[subIndex].submenuItems[subIndex2].rightsId;
                        }
                    }
                }
            }
            return rightsId;
        },
        getRightsIdByRoute: function() {
            var rightsId = '';
            var countRoute = pager.page.route.length;
            if(countRoute == 1 || pager.page.route[0] == 'leads' || pager.page.route[0] == 'opportunity') {
                for(var entity in moveInViewModel.menuConfig) {
                	var route = pager.page.route[0].split("?");
                	route = route[0];
                    if(entity == route) {
                        return moveInViewModel.menuConfig[entity].rightsId;
                    } else if (moveInViewModel.menuConfig[entity].alias == route) {
                    	return moveInViewModel.menuConfig[entity].rightsId;
                    } else {
                        if (pager.page.route[0] == "custom-attributes") {
                            return 7870;
                        } else if (pager.page.route[0] == "recipient-list") {
                            return 8634;
                        }
                    }
                }
            } else if(pager.page.route[0] == 'leads_view'){
                for(var entity in moveInViewModel.menuConfig) {
                    if(entity == 'leads') {
                        return moveInViewModel.menuConfig[entity].rightsId;
                    }
                }
            } else if(pager.page.route[0] == 'opportunity_view') {
                for(var entity in moveInViewModel.menuConfig) {
                    if(entity == 'opportunity') {
                        return moveInViewModel.menuConfig[entity].rightsId;
                    }
                }
            }
            else if (pager.page.route[0] == 'message-center') {
            	return moveInViewModel.menuConfig['label_my_message_c'].rightsId;
            } else if (pager.page.route[0] == 'email-campaign-form') {
            	return moveInViewModel.menuConfig['label_my_email_campaign'].rightsId;
            }
            else if(countRoute > 1 ) {

            	var mainRouteIndex = '';
        		for(var entity in moveInViewModel.menuConfig) {
                    if(entity == pager.page.route[0]) {
                    	mainRouteIndex = entity;
                    } else if (moveInViewModel.menuConfig[entity].alias == pager.page.route[0]) {
                    	mainRouteIndex = entity;
                    }
                }

        		if (pager.page.route[0] == "custom-attributes") {
        			return 7870;
        		}
        		
        		if (pager.page.route[1] == "scoring-admin") {
        		    var scoringurl = window.location.href.split("/").pop();
        		    switch (scoringurl) {
        		        case 'scoring-forms':
        		            return 8629;
        		            break;
        		        case 'scoring-form-type':
        		            return 8651;
                            break;
        		        case 'scoring-type':
        		            return 8628;
                            break;
        		    }
                }

            	if ( mainRouteIndex ) {

            		for(var subIndex in moveInViewModel.menuConfig[mainRouteIndex].submenuItems) {
                        if(moveInViewModel.menuConfig[mainRouteIndex].submenuItems[subIndex].name == pager.page.route[1]) {
                            return moveInViewModel.menuConfig[mainRouteIndex].submenuItems[subIndex].rightsId;
                        } else if(moveInViewModel.menuConfig[mainRouteIndex].submenuItems[subIndex].alias == pager.page.route[1]) {
                        	return moveInViewModel.menuConfig[mainRouteIndex].submenuItems[subIndex].rightsId;
                        }
                    }
            	}
            }
        },
        checkSearchesByPage: function(page) { // check search by page name if a page have view rights then it will show its searches.
            if (moveInViewModel.menuConfig[page]) {
                var rightsId = moveInViewModel.menuConfig[page].rightsId;
                return viewModel.permission.checkRights(rightsId, 'rightView');
            } else {
                switch(page) {
                    case 'referees':
                    case 'boReferees':
                        return viewModel.permission.checkRights(9078, 'rightView'); // please update this code once roles and rights for referees is added
                    break;
                    case 'portalaccounts':
                        return viewModel.permission.checkRights(9088, 'rightView'); // please update this code once roles and rights for referees is added
                    break;
                    case 'contacts':
                        return viewModel.permission.checkRights(9089, 'rightView'); // please update this code once roles and rights for referees is added
                    break;
                    case 'forms':
                        return viewModel.permission.checkRights(9812, 'rightView'); // please update this code once roles and rights for forms is added
                    break;
                    case 'applications':
                        return viewModel.permission.checkRights(9813, 'rightView'); // please update this code once roles and rights for forms is added
                    break;
                    case 'inquiries':
                        return viewModel.permission.checkRights(9814, 'rightView'); // please update this code once roles and rights for forms is added
                    break;
                    case 'interviews':
                        return viewModel.permission.checkRights(9815, 'rightView'); // please update this code once roles and rights for forms is added
                    break;
                    case 'deposits':
                        return viewModel.permission.checkRights(9894, 'rightView'); // please update this code once roles and rights for forms is added
                    break;
                    case 'recipient-list':
                        return true; // please update this code once roles and rights for forms is added
                    break;
                    case 'campaigns':
                        return viewModel.permission.checkRights(8634, 'rightView'); // please update this code once roles and rights for forms is added
                    break;
                    case 'events':
                        return viewModel.permission.checkRights(10164, 'rightView'); // please update this code once roles and rights for forms is added
                        break;
                }
               
            }
        },

        isScorer : function() {
        	//handle case of multiple roles assigned to a single user
        	if(_permissionData() instanceof Array) {
        		for(var index in _permissionData()) {
        			if(_permissionData()[index].scorer == 1){
        				return true
        			}
        		}
        		return false
        	}else{
        		return (_permissionData().scorer == 1)?true:false;
        	}

        },

        isInterviewer : function() {
        	//handle case of multiple roles assigned to a single user
        	if(_permissionData() instanceof Array) {
        		for(var index in _permissionData()) {
        			if(_permissionData()[index].interviewer == 1){
        				return true
        			}
        		}
        		return false
        	}else{
        		return (_permissionData().interviewer == 1)?true:false;
        	}
        },
        
        checkPermissionsForTopMenu : function(callback) {
        	$.when(moveInViewModel.permission.userRightsLoaded).then(function() {
        		callback();
        	});
        }   ,
        checkPackage : function(packageId) {
            for(var i in _packagesData()) {
                if(_packagesData()[i] == packageId){
                    return true;
                }
            }
            return false;
        }

    }

})(moveInViewModel);
